export const isSameDate = (previous: Date, current: Date) => {
  return (
    previous.getFullYear() === current.getFullYear() &&
    previous.getMonth() === current.getMonth() &&
    previous.getDate() === current.getDate()
  )
}
